import { OrderAdjustmentsOrder } from 'pages/OrderAdjustments/types';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useGetOne } from 'react-admin';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { LinearProgress } from 'shared/mui/LinearProgress/LinearProgress';
import { Typography } from 'shared/mui/Typography';
import { getId } from 'utils';

type Props = DialogProps & {
  onExclude: () => void;
  selectedOrder?: OrderAdjustmentsOrder;
};

export const OrderAdjustmentsExcludeDialog = ({
  open,
  onClose,
  onExclude,
  selectedOrder,
}: Props) => {
  const translate = useTypedTranslate();

  const { data: status, isLoading } = useGetOne('order_statuses', {
    id: selectedOrder?.status ?? '',
  });

  const renderContent = () => {
    if (isLoading) {
      return <LinearProgress />;
    }

    const orderId = getId(selectedOrder?.id);
    const statusDescription = status?.description ?? '';

    return (
      <Typography>
        {translate('app.orderAdjustments.excludeDialog.messageStart')}{' '}
        <Typography component="span" fontWeight={500}>
          {orderId}
        </Typography>{' '}
        {translate('app.orderAdjustments.excludeDialog.messageMiddle')}{' '}
        <Typography component="span" fontWeight={500}>
          {statusDescription}
        </Typography>{' '}
        {translate('app.orderAdjustments.excludeDialog.messageEnd')}
      </Typography>
    );
  };

  return (
    <Dialog maxWidth="sm" onClose={onClose} open={open}>
      <CardHeader
        appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
        title={translate('app.orderAdjustments.excludeDialog.title')}
        titleSize="smallBold"
      />
      <CardContent>{renderContent()}</CardContent>
      <CardActionsButtons
        rightActionsSlot={[
          <CancelButton
            key="cancel-button"
            label={translate('app.orderAdjustments.excludeDialog.cancel')}
            onClick={onClose}
            variant="outlined"
          />,
          <Button
            key="save-button"
            label={translate('app.orderAdjustments.excludeDialog.confirm')}
            onClick={onExclude}
            variant="contained"
          />,
        ]}
      />
    </Dialog>
  );
};
